import { render, staticRenderFns } from "./visits.vue?vue&type=template&id=58f3d110&"
import script from "./visits.vue?vue&type=script&lang=js&"
export * from "./visits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports